export const MAX_CHUNK_DURATION = 60 * 5; // wit.ai supports up to 5 mins

export const MIN_CHUNK_DURATION = 4; // minimum 4s duration

export const MIN_CONCURRENCY = 1;
